import React from 'react';
export const TrustedBy = () => {
  const partners = [{
    name: 'BE Labs',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rz8TZat77kxpjqLhFLM5fx/BE_Labs.png'
  }, {
    name: 'Craig Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ntTF4CDfLTXz8WATTfepgn/Craig_Group.png'
  }, {
    name: 'Gleantap',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b3im3xK8HfWSUpUZoF3rC1/Gleantap.png'
  }, {
    name: 'KENTECH',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jFVATaxBjLzmHvYRzAJ2AK/KENTECH_copy.png'
  }, {
    name: 'Innervate',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bokQLKvM4Qf41iQQ3fX49e/Innervate.png'
  }, {
    name: 'eKnowID',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5sfib6zZyMh7Nw5ECy2USo/eknowid.png'
  }, {
    name: 'mniche',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nu6hkUhm2MZyMAewKZpeeY/mniche_logo_Transparent.png'
  }];
  return <section className="py-10 bg-purple-50 relative overflow-hidden" data-id="element-522">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-523">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 max-w-4xl mx-auto" data-id="element-524">
          {partners.map((partner, index) => <div key={index} className="flex items-center opacity-50 hover:opacity-80 transition-opacity" data-id="element-525">
              <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-8 md:max-h-10 filter grayscale" style={{
            maxWidth: '120px'
          }} data-id="element-526" />
            </div>)}
        </div>
      </div>
    </section>;
};